
export default function isRightClick(event: MouseEvent) {
  return event.button === 2
}
